<template>
    <transition name="toolbar-slide">
        <div v-if="isToolbarVisible" class="emails-toolbar-container">
            <div class="emails-toolbar">
                <span class="typographies-paragraph-medium-bold btn-cancel-selected-items">
                    <CompassIconButton icon="close" variant="contrast" @click="closeToolbar" />
                    {{
                        $t.n__(
                            'common.labels.selected',
                            null,
                            selectedEmails.length,
                            selectedEmails.length,
                        )
                    }}
                </span>
                <CompassButton
                    :label="$t.__('common.actions.manage_related')"
                    type="tertiary-contrast"
                    leftIcon="objects-linked"
                    @click="handleUpdateRelated"
                />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        selectedEmails: {
            type: Array,
            default: () => [],
        },
        isToolbarVisible: {
            type: Boolean,
        },
    },
    methods: {
        closeToolbar() {
            this.$emit('closeToolbar');
        },
        handleUpdateRelated() {
            this.$emit('open:related', this.selectedEmails);
        },
    },
};
</script>

<style scoped lang="scss">
.toolbar-slide-enter-active,
.toolbar-slide-leave-active {
    transition: transform 0.3s ease;
}

.toolbar-slide-enter,
.toolbar-slide-leave-to {
    transform: translateY(110px);
}

.toolbar-slide-enter-to,
.toolbar-slide-leave {
    transform: translateY(0);
}

.emails-toolbar-container {
    position: fixed;
    left: 50%;
    bottom: 40px;
    z-index: 2;
    transform: translateX(-50%);
}

.emails-toolbar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-radius: var(--spacing-0);
    padding: var(--spacing-3) var(--spacing-4);
    gap: var(--spacing-3);
    color: var(--colors-common-text-standard-on-color);
    background-color: var(--colors-common-border-primary-hover);
}

.btn-cancel-selected-items {
    display: flex;
    align-items: center;
    gap: var(--spacing-0);
    padding-right: var(--spacing-4);
    border-right: 1px solid var(--colors-common-border-lighter);
}
</style>
